module.exports = __webpack_public_path__ + "media/images/icon-checkmark-f60153fb.svg";